import { useMemo } from 'react';

import { DRAWER_WIDTH, MuiDrawer as Drawer, Typography } from '@/shared/ui';

import { Z_INDEX } from '@/config/z-index';
import { AppForm } from '@/features/dashboard/components/AppForm/AppForm';
import {
  DrawerStep,
  useDrawerSteps
} from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { AppSelector } from '@/features/dashboard/components/Drawer/steps/AppSelector';
import { ImportMarketWidget } from '@/features/dashboard/components/Drawer/steps/ImportMarketWidget';
import { Dialog, DialogButton } from '@/shared/ui/overlays/Modal';
import presets from '@/shared/ui/overlays/Modal/presets';

export const DashboardDrawer = () => {
  const { drawerStep, confirmOpen, handleAttemptClose, handleConfirmClose, handleCancelClose } =
    useDrawerSteps();

  const content = useMemo(() => {
    switch (drawerStep) {
      case DrawerStep.SelectApp:
        return <AppSelector />;
      case DrawerStep.SelectMarketWidget:
        return <ImportMarketWidget />;
      default:
        return <AppForm />;
    }
  }, [drawerStep]);

  return (
    <>
      <Drawer
        anchor='right'
        open={Boolean(drawerStep)}
        sx={{ zIndex: Z_INDEX.panel }}
        slotProps={{
          paper: {
            sx: theme => ({
              width: { xs: '100%', sm: DRAWER_WIDTH },
              maxWidth: '100%',
              boxSizing: 'border-box',
              marginLeft: 'auto',
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: theme.palette.gx.mainBackground
            })
          },
          backdrop: {
            sx: {
              backgroundColor: 'rgba(18, 22, 63, 0.80)'
            },
            // Block default backdrop click close; we'll route it to onClose where we can decide
            onClick: handleAttemptClose
          }
        }}
        variant='temporary'
        onClose={(_e, reason) => {
          if (reason !== 'escapeKeyDown') handleAttemptClose();
        }}
      >
        {content}
      </Drawer>
      <Dialog
        buttons={
          <>
            <DialogButton
              variant='outlined'
              onClick={() => {
                handleCancelClose();
              }}
            >
              {presets.discard.cancelText}
            </DialogButton>
            <DialogButton
              variant='contained'
              onClick={() => {
                handleConfirmClose();
              }}
            >
              {presets.discard.confirmText}
            </DialogButton>
          </>
        }
        open={confirmOpen}
        title={presets.discard.title}
        onClose={handleCancelClose}
      >
        <Typography>{presets.discard.text}</Typography>
      </Dialog>
    </>
  );
};
